module.exports = __webpack_public_path__ + "static/media/astronauta_5.ca598e0b.svg";